import usePagedQuery, { PagedQueryArgs } from '../usePagedQuery';
import { OrdersData } from '../../types/IOrderResponse';

export default function useOrderList(args: PagedQueryArgs) {
  return usePagedQuery<OrdersData>('order-list', 'api/orders', args);
}
